export enum CheckInProcessSteps {
    ReservationDetails = 'ReservationDetails',
    DriverLicense = 'DriverLicense',
    GotCheckInMessage = 'GotCheckInMessage',
    DriverDetails = 'DriverDetails',
    CarSelection = 'CarSelection',
    ProductsSelection = 'ProductsSelection',
    Summary = 'Summary',
    Deposit = 'Deposit',
    ContractSigning = 'ContractSigning',
    FinalScreen = 'FinalScreen',
    DriverAddress = 'DriverAddress',
    AddDriverLicense = 'AddDriverLicense'
}
